/* global d3:true, _:true */

(function() {
    'use strict';

    angular.module('eDocumentsApp').controller('LandingPageController', LandingPageController);

    LandingPageController.$inject = [
        '$scope',
        'Account',
        'Principal',
        '$state',
        'Auth',
        '$rootScope',
        '$translate',
        'PaginationUtil',
        'Notification',
        'ContactUsService',
        'DocumentationUtils',
        '$sessionStorage',
        'LoginService'
    ];

    function LandingPageController(
        $scope,
        Account,
        Principal,
        $state,
        Auth,
        $rootScope,
        $translate,
        PaginationUtil,
        Notification,
        ContactUsService,
        DocumentationUtils,
        $sessionStorage,
        LoginService
    ) {
        var vm = this;
        vm.authenticationError = false;
        vm.credentials = {};
        vm.password = null;
        vm.rememberMe = true;
        vm.email = null;
        vm.isSaving = false;
        vm.addToNewsletter = addToNewsletter;
        vm.login = login;
        vm.downloadManual = downloadManual;
        vm.userManualUrl = userManualUrl;
        vm.contactUs = contactUs;
        $scope.$on('authenticationSuccess', function() {
            // A page asked for while signed out is restored by whoever signed in (LoginController, or vm.login below);
            // sending the user home here as well overrode it. Checked now: the sign-in clears it right after this event.
            if (Auth.getPreviousState()) {
                return;
            }
            init();
        });

        function addToNewsletter() {
            vm.isSaving = true;
            Account.addToNewsletter(
                {
                    email: vm.email
                },
                function() {
                    Notification.success({
                        message: $translate.instant('global.addToNewsletter.success.message'),
                        delay: 5000
                    });
                    vm.email = '';
                    vm.isSaving = false;
                },
                function() {
                    Notification.error({
                        message: $translate.instant('global.addToNewsletter.error.message'),
                        delay: 5000
                    });
                    vm.isSaving = false;
                }
            );
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            })
                .then(function() {
                    PaginationUtil.resetFilters();
                    vm.authenticationError = false;
                    $rootScope.$broadcast('authenticationSuccess');
                    if (Auth.getPreviousState()) {
                        Auth.goToPreviousState();
                    } else {
                        $state.go(Principal.homeState());
                    }
                })
                .catch(function() {
                    vm.authenticationError = true;
                });
        }

        init();

        function init() {
            Principal.identity().then(function(account) {
                if (account && account.login) {
                    $state.go(Principal.homeState());
                } else if ($sessionStorage.accessExpired) {
                    // SUP-12293: signed out because the account's access ended - tell the user why
                    LoginService.open();
                }
            });
        }

        function downloadManual() {
            DocumentationUtils.openUserManual();
        }

        function userManualUrl() {
            return DocumentationUtils.userManualUrl();
        }

        function contactUs() {
            ContactUsService.open();
        }
    }
})();
